<template>
    <div class="game-create-container create-container">
        <div class="create-host">
            <div class="jc-page-header">
                <div class="jc-container">
                    <el-page-header show-back-icon :title="$t('game.create.buyInstance')" @back="goList" class="relative">
                        <template slot="content">
                            <div class="jc-list__header--right">
                                <a :href="Config.BUY_HELP_URL" target="_blank" class="fr buy-info">
                                    {{ $t('create.text.buyMustKnow') }}
                                </a>
                            </div>
                        </template>
                    </el-page-header>
                </div>
            </div>
            <div class="jc-page-content">
                <div class="jc-container">
                    <div class="buildCon" v-loading="skuloading">
                        <div class="jc-page-card">
                            <el-form class="jc-form cps-create-form" label-width="100px" :model="ruleForm" ref="ruleForm"
                                :rules="rules">
                                <!--游戏-->
                                <el-form-item :label="$t('game.create.game')" class="mb0">
                                    <div class="gcs-card-box">
                                        <section v-for="item in games" :key="item.gameId" @click="changeCard(item)">
                                            <el-card class="gcs-card game-card"
                                                :class="{ 'selected-card': item.gameId === selectedImageId }">
                                                <el-tooltip effect="dark" placement="right" popper-class="game-tip"
                                                    :open-delay=300>
                                                    <template slot="content">
                                                        <p class="game-tip-name">{{ item.appName }}</p>
                                                        <p class="game-tip-title">{{ item.appDesc }}</p>
                                                        <p class="game-tip-content" v-if="item.showAppTips">{{
                                                            $t('game.create.tips.wukong')
                                                        }}</p>
                                                    </template>
                                                    <section class="image-container">
                                                        <p class="image-icon">
                                                            <img :src="item.iconUrl" :alt="item.appName" />
                                                        </p>
                                                        <div class="image-content">
                                                            <p class="image-up-title">{{ item.appName }}</p>
                                                            <p class="image-down-intro"
                                                                :class="{ 'special-intro': item.isSpecial }">{{
                                                                    item.appDesc
                                                                }}
                                                            </p>
                                                        </div>
                                                    </section>
                                                    <!-- <template slot="content">
                                                        <p class="game-tip-title">{{ item.appDesc }}</p>
                                                        <p class="game-tip-content">{{ item.appTips }}</p>
                                                    </template>
                                                    <section class="image-container">
                                                        <p class="image-icon wukong">
                                                        </p>
                                                        <div class="image-content">
                                                            <p class="image-up-title">{{ item.appName }}</p>
                                                            <p class="image-down-intro">{{ item.appDesc }}</p>
                                                        </div>
                                                    </section> -->
                                                </el-tooltip>
                                            </el-card>
                                        </section>
                                    </div>
                                </el-form-item>
                                <!--计费方式-->
                                <el-form-item :label="$t('detail.text.billingMethods')">
                                    <el-radio-group v-model="timeUnit" @change="changeTimeUnit">
                                        <el-radio-button v-for="item in TimeUnitConstant" :key="item.value"
                                            :label="item.value">
                                            <span>{{ item.label }}</span>
                                            <img v-if="item.value === 1" src="~@/assets/img/game/hot.png" class="hot-img" />
                                            <img v-if="item.value === 3" src="~@/assets/img/game/hui.png" class="hot-img" />
                                        </el-radio-button>
                                    </el-radio-group>
                                    <el-tooltip effect="dark" placement="right" popper-class="charge-mode-tip">
                                        <div slot="content">
                                            <p class="charge-mode-tip-item">
                                                <span class="label">{{ $t('game.create.payByHour') | withColon }}</span>
                                                <span>{{ $t('game.create.tips.payByHour') }}</span>
                                            </p>
                                            <p class="charge-mode-tip-item">
                                                <span class="label">{{ $t('game.create.payByDay') | withColon }}</span>
                                                <span>{{ $t('game.create.tips.payByDay') }}</span>
                                            </p>
                                        </div>
                                        <a class="ml10"><i class="jc-icon-question"></i></a>
                                    </el-tooltip>
                                </el-form-item>
                                <!--地域-->
                                <el-form-item :label="$t('create.text.region')">
                                    <el-radio-group v-model="selectedRegion">
                                        <el-radio-button v-for="(regionName, region) in regions" :key="region"
                                            :label="region">
                                            {{ regionName }}
                                        </el-radio-button>
                                        <!-- 返回边缘edcps游戏创建列表页 -->
                                        <el-button @click="jumpToEDCPSGame" style="vertical-align: middle;">{{
                                            $t('game.action.backCPSGameListText') }}<i
                                                class="el-icon-top-right el-icon--right"></i></el-button>
                                    </el-radio-group>
                                </el-form-item>
                                <!--配置-->
                                <el-form-item :label="$t('game.create.configuration')" class="configuration-form-item">
                                    <div class="gcs-card-box" v-if="modelsList.length">
                                        <section v-for="item in modelsList" :key="item.id" @click="selectDeviceType(item)">
                                            <el-card class="gcs-card"
                                                :class="[{ 'selected-card': item.id === selectedDeviceTypeId && deviceTypes[item.deviceType] }, { 'disabled-card': !deviceTypes[item.deviceType] }]">
                                                <div slot="header"
                                                    :class="{ 'active-card': item.id === selectedDeviceTypeId && deviceTypes[item.deviceType] }">
                                                    <img src="~@/assets/img/game/discount.png" class="discount-img" v-show="item.totalDiscount" />
                                                    <span class="item text">{{ item.name }}</span>
                                                </div>
                                                <div class="specification-content">
                                                    <span class="every-price">{{ everyCountLoading ?
                                                        $t('create.text.calculating') :
                                                        $t('game.create.feePer',
                                                            [item.discountByConfigurationsPricePerHour]) }} / </span>
                                                    <span class="every-price f12">{{ feeUnit(timeUnit) }}</span>
                                                    <span class="origin-price f12 pl15 line-through" v-show="item.totalDiscount">¥{{ item.totalOriginalPrice }}</span>
                                                    <p class="specification-content-item">
                                                        <span class="dot"></span>
                                                        <span class="label">{{ $t('game.create.gpu') | withColon(': ')
                                                        }}</span>
                                                        <span class="value">{{
                                                            $t('game.list.specificationType.gpu', [item.gpuDesc,
                                                            item.gpuMemory]) }}</span>
                                                    </p>
                                                    <p class="specification-content-item">
                                                        <span class="dot"></span>
                                                        <span class="label">{{ $t('game.create.cpu') |
                                                            withColon(':') }}</span>
                                                        <span class="value">{{
                                                            $t('game.list.specificationType.cpu', [item.cpu,
                                                            item.cpuCore]) }}</span>
                                                    </p>
                                                    <p class="specification-content-item">
                                                        <span class="dot"></span>
                                                        <span class="label">{{ $t('game.create.memory') | withColon(':')
                                                        }}</span>
                                                        <span class="value">{{
                                                            $t('game.list.specificationType.memory', [item.memoryDesc,
                                                            item.memory]) }}</span>
                                                    </p>
                                                    <p class="specification-content-item">
                                                        <span class="dot"></span>
                                                        <span class="label">{{ $t('game.create.sysDisk') | withColon(':')
                                                        }}</span>
                                                        <span class="value">{{
                                                            $t('game.list.specificationType.sysDisk', [item.systemDisk,
                                                            item.systemDiskType]) }}</span>
                                                    </p>
                                                    <p class="specification-content-item">
                                                        <span class="dot"></span>
                                                        <span class="label">{{ $t('game.create.eip') |
                                                            withColon(':') }}</span>
                                                        <span class="value">{{
                                                            $t('game.list.specificationType.bw', [item.bw]) }}</span>
                                                    </p>
                                                </div>
                                                <span v-if="!deviceTypes[item.deviceType]" class="sold-out">{{
                                                    $t('game.create.soldOut') }}</span>
                                            </el-card>
                                        </section>
                                    </div>
                                    <el-empty v-else description="暂无数据" :image-size="100"></el-empty>
                                </el-form-item>
                                <!--用户名-->
                                <el-form-item :label="$t('create.text.username')" class="username-form-item">
                                    <span>{{ userName }}</span>
                                </el-form-item>
                                <!--密码-->
                                <el-form-item :label="$t('create.text.password')" required prop="hostPwd"
                                    :show-message="false" ref="hostPwd" class="password-form-item">
                                    <section class="password-content">
                                        <section class="password-item fl">
                                            <el-input class="pwd-input" v-model="ruleForm.hostPwd" type="password"
                                                v-show="!pwdEyes" auto-complete="off" @blur="ruleFormTag.hostPwd = 1"
                                                @focus="ruleFormTag.hostPwd = 0"></el-input>
                                            <el-input class="pwd-input" v-model="ruleForm.hostPwd" type="input"
                                                v-show="pwdEyes" auto-complete="off" @blur="ruleFormTag.hostPwd = 1"
                                                @focus="ruleFormTag.hostPwd = 0"></el-input>
                                            <span class="eyes" @click="changePwdEyes"
                                                :class="{ 'opened-eyes': pwdEyes, 'closed-eyes': !pwdEyes }"></span>
                                        </section>
                                        <section class="random-password">
                                            <span class="random-password-btn" @click="generatePwd">
                                                <span class="random-password-icon"></span>
                                                <span class="randowm-password-txt">{{ $t('game.create.generatePwd')
                                                }}</span>
                                            </span>
                                            <el-tooltip effect="dark" placement="right" popper-class="charge-mode-tip">
                                                <div slot="content">
                                                    <p class="charge-mode-tip-item">
                                                        {{ $t('game.create.randomPasswordTip1') }}
                                                    </p>
                                                    <p class="charge-mode-tip-item">
                                                        {{ $t('game.create.randomPasswordTip2') }}
                                                    </p>
                                                    <p class="charge-mode-tip-item">
                                                        {{ $t('game.create.randomPasswordTip3') }}
                                                    </p>
                                                </div>
                                                <a><i class="jc-icon-question"></i></a>
                                            </el-tooltip>
                                        </section>
                                    </section>
                                    <p v-if="ruleFormTag.hostPwd !== 0 && ruleForm.hostPwd == ''"
                                        class="el-form-item-help-error">
                                        {{ $t('create.placeholder.passNull') }}</p>
                                    <p v-else class="el-form-item-help"
                                        :class="{ 'el-form-item-help-error': this.ruleFormTag.hostPwd == 'error' }">
                                        {{ $t('create.help.password') }}</p>
                                </el-form-item>
                                <!--确认密码-->
                                <el-form-item :label="$t('create.text.passwordConfirm')" required prop="hostConfirmPwd"
                                    :show-message="false" ref="hostConfirmPwd">
                                    <section class="password-item">
                                        <el-input class="pwd-input" v-model="ruleForm.hostConfirmPwd" type="password"
                                            v-show="!confirmPwdEyes" auto-complete="off"
                                            @blur="ruleFormTag.hostConfirmPwd = 1"
                                            @focus="ruleFormTag.hostConfirmPwd = 0"></el-input>
                                        <el-input class="pwd-input" v-model="ruleForm.hostConfirmPwd" type="input"
                                            v-show="confirmPwdEyes" auto-complete="off"
                                            @blur="ruleFormTag.hostConfirmPwd = 1"
                                            @focus="ruleFormTag.hostConfirmPwd = 0"></el-input>
                                        <span class="eyes" @click="changeConfirmPwdEyes"
                                            :class="{ 'opened-eyes': confirmPwdEyes, 'closed-eyes': !confirmPwdEyes }"></span>
                                    </section>
                                    <p v-if="ruleFormTag.hostConfirmPwd !== 0 && ruleForm.hostConfirmPwd == ''"
                                        class="el-form-item-help-error">
                                        {{ $t('create.placeholder.confirmPassNull') }}</p>
                                    <p v-if="ruleFormTag.hostConfirmPwd !== 0 && ruleForm.hostConfirmPwd !== '' && ruleForm.hostPwd !== ruleForm.hostConfirmPwd"
                                        class="el-form-item-help-error">{{ $t('create.placeholder.passNotSame') }}</p>
                                </el-form-item>
                                <!--购买时长-->
                                <el-form-item v-if="chargeMode === 3" :label="$t('create.text.buySpan')"
                                    :title="$t('create.text.buyTimeSpan')">
                                    <el-select v-model="selectedMonth" size="mini" @change="changeMonth">
                                        <el-option :label="item.name" :value="item.value" v-for="item in months"
                                            :key="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jc-page-footer" v-loading="skuloading">
                <div class="jc-container pr">
                    <section class="config-infor">
                        <!-- 配置费用 -->
                        <el-tooltip effect="dark" placement="top" popper-class="fee">
                            <div slot="content">
                                <section class="fee-title">{{ $t('game.create.feeDetail') }}</section>
                                <el-table :data="feeDetailData" style="width: 380px" :header-cell-style="headerCellStyle"
                                    :cell-style="addClass">
                                    <el-table-column show-overflow-tooltip prop="itemName" min-width="80px"
                                        :label="$t('game.create.feeItem')">
                                    </el-table-column>
                                    <el-table-column prop="originalPrice" :label="$t('game.create.originPrice')"
                                        show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="discount" :label="$t('game.create.discount')"
                                        show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="itemAfterFavorablePrice" :label="$t('game.create.cost')"
                                        show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span
                                                :style="(scope.$index === feeDetailData.length - 1) ? 'color:red' : 'color:#fff'">{{
                                                    scope.row.itemAfterFavorablePrice }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <span class="bm-dashed">{{ $t('game.create.configFee') | withColon }}</span>
                        </el-tooltip>
                        <span class="price">{{ configurationsPrice }}</span>
                        <!-- <span v-if="chargeMode === 1" class="price">{{ countLoading ? $t('create.text.calculating') :
                            $t('game.create.feePerHour', [discountByConfigurationsPricePerHour])
                        }}</span>
                        <span v-else class="price">{{ countLoading ? $t('create.text.calculating') :
                            $t('game.create.feePerDay', [discountByConfigurationsPricePerHour])
                        }}</span> -->
                        <span v-show="favorablePricePerHour" class="favorablePrice pl15">省：{{ countLoading ? $t('create.text.calculating') : $t('game.create.feePer', [favorablePricePerHour]) }}</span>
                        <span v-if="chargeMode === 1 && favorablePricePerHour" class="favorablePrice">/{{ feeUnit(timeUnit) }}</span>
                        <!-- 配置明细 -->
                        <el-tooltip effect="dark" placement="top-start" popper-class="config">
                            <div slot="content">
                                <section>{{ $t('game.create.configDetail') }}</section>
                                <!-- 游戏 -->
                                <p>
                                    <span>{{ $t('game.create.game') | withColon(': ') }}</span>
                                    <span>{{ (selectedGame.appName) | maybeEmpty }}</span>
                                </p>
                                <!-- 地域 -->
                                <p>
                                    <span>{{ $t('create.text.region') | withColon(': ') }}</span>
                                    <span>{{ regions[selectedRegion] | maybeEmpty }}</span>
                                </p>
                                <!-- 规格 -->
                                <p>
                                    <span>{{ $t('create.text.spec') | withColon(': ') }}</span>
                                    <span>{{ selectedDeviceType.name | maybeEmpty }}</span>
                                </p>
                                <p>
                                    <span>{{ $t('game.create.gpu') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.gpu', [selectedDeviceType.gpuDesc,
                                        selectedDeviceType.gpuMemory]) }}</span>
                                </p>
                                <p>
                                    <span>{{ $t('game.create.cpu') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.cpu', [selectedDeviceType.cpu,
                                        selectedDeviceType.cpuCore]) }}</span>
                                </p>
                                <p>
                                    <span>{{ $t('game.create.memory') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.memory', [selectedDeviceType.memoryDesc,
                                        selectedDeviceType.memory]) }}</span>
                                </p>
                                <p>
                                    <span>{{ $t('game.create.sysDisk') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.sysDisk', [selectedDeviceType.systemDisk,
                                        selectedDeviceType.systemDiskType]) }}</span>
                                </p>
                                <p>
                                    <span>{{ $t('game.create.eip') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.bw', [selectedDeviceType.bw]) }}{{ chargeMode === 3
        ?
        ' 按月' : ' 按小时' }}-按固定带宽</span>
                                </p>
                            </div>
                            <span class="ml20 bm-dashed">{{ $t('game.create.configDetail') }}</span>
                        </el-tooltip>
                    </section>
                    <el-button v-if="isCertification" type="primary" size="large" @click="buy" class="buy-button"
                        :disabled="!deviceTypes[selectedModel]">
                        <span>
                            {{ !deviceTypes[selectedModel] ? $t('game.create.soldOut') : $t('game.create.buyNow') }}
                        </span>
                        <!-- <el-tooltip v-else effect="dark" placement="top" :content="$t('instance.create.noStock')">
                            <span>
                                {{ $t('create.text.buyNow') }}
                            </span>
                        </el-tooltip> -->
                    </el-button>
                    <el-button v-else type="primary" size="large" class="buy-button" :disabled="true">
                        <span>
                            {{ $t('create.text.buyNow') }}
                        </span>
                    </el-button>
                    <!--尚未通过实名认证-->
                    <p v-if="!isCertification" style="text-align: right;" class="red mt10">
                        {{ $t('create.help.noCertification') }}
                        <a :href="Config.REALNAME_URL">
                            {{ $t('create.help.goCertificate') }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
// import { generatePassword3 } from 'random-1password';
import { local_generatePassword3 } from '@/common/localGeneratePassword/index'
import { TimeUnitConstant, NetworkTypeConstant, CreateTypeConstant, I18nConstant, ServiceCodeConstant, GameRegionsConstant, PasswordRuleConstant, BillingTypesConstant } from '@/common/Constants';
import {
    getGameSpecsApi,
    createGameInstanceApi,
} from '@/api/game/actions';
import ifCertification from '@/mixins/ifCertification';
import isDestroyingMixins from '@/mixins/isDestroying';
import {

    getCalculateTotalPriceApi,
} from '@/api/common/actions';
import { changeTwoDecimal, guid, subDecimals, mulDecimals, divDecimals } from '@/common/tool';
import _ from 'lodash';
export default {
    components: {

    },
    mixins: [ifCertification, isDestroyingMixins],
    data() {
        const validatePassword = (rule, value, callback) => {
            var rule = PasswordRuleConstant
            const result = rule.test(value);
            if (!result) {
                callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
                return;
            }
            callback();
        };

        const validateConfirmPassword = (rule, value, callback) => {
            if (value == '') {
                callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
            } else if (value != this.ruleForm.hostPwd) {
                callback(new Error(this.$t('create.placeholder.passwordNotSame')));
            } else {
                callback();
            }
        };
        return {
            skuloading: true,
            games: [],
            chargeMode: 1,// 计费类型，1: 按小时,3: 包月，
            timeUnit: 1, // 计费方式，1：按小时，3：包月
            selectedRegion: '',
            selectedAz: '',
            regions: {},
            zones: { '': {} },
            selectedGame: {},
            models: [{}],
            modelsList: [], // 根据ids字段 筛选出 符合镜像的配置信息
            selectedDeviceType: {},
            selectedDeviceTypeId: '',
            selectedModel: '',
            selectedBw: '',
            selectedImageId: '',
            systemRaid: {},
            everyCountLoading: false,
            selectedQuantity: 1,
            feeDetailData: [],
            countLoading: true,
            deviceTypes: {},
            // 配置项是否有库存存储变量
            deviceTypesIds: {},
            lineType: '',
            radisNameMap: {
                NORAID: 'NO RAID',
                RAID0: 'RAID0',
                RAID1: 'RAID1',
                RAID10: 'RAID10',
                RAID5: 'RAID5',
                RAID51H: 'RAID 5+1 hotspare+NO RAID'
            },
            certificationDialogVisible: false,
            isStock: true,
            TimeUnitConstant: TimeUnitConstant,
            userName: "administrator",
            // 表单验证
            ruleForm: {
                hostPwd: '',
                hostConfirmPwd: '',
            },
            ruleFormTag: {
                hostPwd: 0,
                hostConfirmPwd: 0,
            },
            rules: {
                hostName: [
                    {
                        type: 'string',
                        pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:{}]{1,127})$'),
                        trigger: 'blur'
                    }
                ],
                hostPwd: [
                    { validator: validatePassword, trigger: 'blur' }
                ],
                hostConfirmPwd: [
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ],
            },
            pwdEyes: false,
            confirmPwdEyes: false,
            selectedMonth: 1,
            months: [
                {
                    name: '1个月',
                    value: 1
                },
                {
                    name: '2个月',
                    value: 2
                },
                {
                    name: '3个月',
                    value: 3
                },
                {
                    name: '4个月',
                    value: 4
                }, {
                    name: '5个月',
                    value: 5
                },
                {
                    name: '6个月',
                    value: 6
                },
            ],
            GameRegionsConstant: GameRegionsConstant,
            favorablePricePerHour: '', // // 省 = 原价 - 应付
            statusTimeOut: null,
            discountByConfigurationsPricePerHour: null
        }
    },
    computed: {
        configurationsPrice() {
            if ([undefined, null].includes(this.discountByConfigurationsPricePerHour)) return '--';
            if (this.chargeMode === 1) {
                return this.countLoading ? this.$t('create.text.calculating') : this.$t('game.create.feePerHour', [this.discountByConfigurationsPricePerHour]);
            } else {
                return this.countLoading ? this.$t('create.text.calculating') : this.$t('game.create.feePerDay', [this.discountByConfigurationsPricePerHour]);
            }
        }
    },
    watch: {
        selectedRegion(newValue, oldVlue) {
            if (newValue) {
                if (this.zones[this.selectedRegion]) {
                    for (const az in this.zones[this.selectedRegion]) {
                        this.selectedAz = az;
                        break;
                    }
                } else {
                    this.selectedAz = '';
                }
                this.getLineTypes();
                this.getModels();
            }
        },

        selectedModel(newValue, oldVlue) {
            if (newValue) {
                this.getAvailableOS();
                this.getAvailableRaids(newValue);
            }

        },
        selectedImageId(newValue) {
            this.feeDetailData = [];
            this.discountByConfigurationsPricePerHour = null;
            if (!this.lineType) {
                return
            }
            this.getModels();
        },
        models(newValue) {
            // 配置信息根据 /describeImages 接口返回的 ids:[1,2,3,4] 匹配 /listGameSpecs 接口返回的id(唯一), 筛选出符合镜像的配置信息
            this.modelsList = [];
            const specsData = _.groupBy(newValue, 'id');
            const selectedImageIdData = this.games?.length && this.games.find(item => {
                return item.gameId === this.selectedImageId;
            })
            for (const key in specsData) {
                if (selectedImageIdData && selectedImageIdData?.ids.includes(Number(key))) {
                    this.modelsList.push(specsData[key][0]);
                }
            }
        }
    },
    created() {
        this.getRegions();
        this.getUserIsCertification();
    },
    beforeDestroy() {
        // 离开页面前销毁缓存中的md5，每次进入该页面重新存
        if (localStorage.getItem(`md5-${this.selectedRegion}`)) {
            localStorage.removeItem(`md5-${this.selectedRegion}`);
        }
    },

    methods: {
        getAvailableOSTimeout() {
            clearTimeout(this.statusTimeOut);
            const param = { region: this.selectedRegion };
            Ajax.get('/api/cps/instances/describeImages', param).then(res => {
                /**
                 * md5 用于区分镜像配置是否已更新
                 * 如果已经存到md5 和 请求回来的新的md5 不同，则重新请求此页面的接口
                 */
                const { md5 } = res.data || {};
                const savedMd5 = localStorage.getItem(`md5-${this.selectedRegion}`) || '';
                if (md5 && !savedMd5) {
                    localStorage.setItem(`md5-${this.selectedRegion}`, md5);
                }
                if (md5 && savedMd5 && md5 !== savedMd5) {
                    localStorage.setItem(`md5-${this.selectedRegion}`, md5);
                    this.getAvailableOS();
                    this.getModels();
                    this.getUserIsCertification();
                    return;
                }
                this.statusTimeOut = setTimeout(() => {
                    this.getAvailableOSTimeout();
                }, 6000);
            });
        },
        /**
         * @description 跳转边缘edcps云物理服务器游戏列表页
         * @description 读取edcps开通游戏服务器的白名单地域第一个值
        */
        jumpToEDCPSGame() {
            window.open(`//cps-edge-console.jdcloud.com/instance/game/create?region=${this.Config.EDCPS_GAME_REGION_WHITELIST[0]}`, '_blank');
        },
        goList() {
            this.$router.push({
                path: '/instance/game/list'
            });
        },

        getLineTypes() {
            const param = {
                region: this.selectedRegion
            };
            Ajax.get('/api/cps/getLineTypes', param)
                .then((res) => {
                    if (res.data.lineTypes.length) {
                        this.lineType = res.data.lineTypes[0].lineType
                    }

                }).catch(async (err) => {
                    const { response } = err.data || {};
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },

        handleClose(done) {
            done();
        },

        jumpToHelpCenter() {
            //window.open(this.$urls.instanceHelpUrl, '_blank');
        },

        jumpToService() {
            window.open('https://jtk.jd.com/index.htm?entrance=154&source=web#/chat', '_blank');
        },
        changeTimeUnit() {
            this.chargeMode = this.timeUnit === 1 ? 1 : 3;
            this.getCalculateTotalPrice();
            this.fetchPricesAndUpdateModels();
        },
        generateGuid() {
            return guid();
        },
        getRegions() {
            const param = {
                networkType: NetworkTypeConstant.VPC
            };
            Ajax.get('/api/cps/getRegions', param)
                .then((res) => {
                    let regions = res.data.regions.filter(item => this.GameRegionsConstant.includes(item.region));
                    for (const i in regions) {
                        const region = regions[i].region;
                        const regionName = regions[i].regionName;
                        this.regions[region] = regionName;
                        const zones = regions[i].azs;
                        for (const j in zones) {
                            const az = zones[j].az;
                            const azName = zones[j].azName;
                            if (typeof this.zones[region] === 'undefined') {
                                this.zones[region] = {};
                            }
                            this.zones[region][az] = azName;
                        }
                    }
                    const passedRegion = this.$route.query.region;
                    if (passedRegion != undefined) {
                        this.selectedRegion = passedRegion;
                    } else {
                        this.selectedRegion = regions[0].region;
                    }

                }).catch(async (err) => {
                    const { response } = err.data || {};
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        /**
         * 根据计费方式的不同改变单价单位
         * @param timeUnit 计费方式单位
         * @retunrs 每个计费方式的单位，每个月，每小时
         */
        feeUnit(timeUnit) {
            switch (timeUnit) {
                case 3:
                    return this.$t('game.create.oneDay');
                default:
                    return this.$t('game.create.oneHour');
            }
        },
        headerCellStyle() {
            return {
                background: 'rgba(0,0,0,.85)',
                color: '#fff',
                borderBottom: '1px solid #999',
            }
        },
        addClass() {
            return 'background: rgba(0,0,0,.85);color:#fff;border-bottom:1px solid #999';
        },

        certificationBuy(data) {
            this.certificationDialogVisible = data.visible;
        },
        buy() {
            let formValid = true;
            this.$refs.ruleForm.validate((valid) => {
                formValid = valid;
            });
            if (!formValid) {
                return
            }
            const param = {
                az: this.selectedAz,
                region: this.selectedRegion,
                deviceType: this.selectedModel,
                osTypeId: this.selectedGame.gameId,
                sysRaidTypeId: this.systemRaid.sysRaidTypeId,
                deviceName: this.selectedDeviceType.name,
                imageName: this.selectedGame.appName, //后端创建订单时展示用
                sysRaidName: this.systemRaid.sysRaidName,
                // name: '黑神话:悟空',
                password: this.ruleForm.hostPwd,
                bw: this.selectedBw,
                internetChargeMode: this.chargeMode,
                gameConfigId: this.selectedDeviceTypeId,
                orderType: 1,
                chargeMode: this.chargeMode,
                chargeDuration: this.chargeMode === 3 ? this.selectedMonth : 1,
                chargeUnit: this.chargeMode === 3 ? 3 : 1,
                quantity: this.selectedQuantity,
                lineType: this.lineType,
                name: this.selectedGame.imageName,
            };
            createGameInstanceApi(param).then(res => {
                const orderId = res.data.tempOrderNumber;
                if (orderId) {
                    window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
                }
            })
                .catch(async (err) => {
                    const { response } = err.data || {};
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        getAvailableOS() {
            const param = { region: this.selectedRegion };
            return Ajax.get('/api/cps/instances/describeImages', param).then(res => {
                let showAppTips, isSpecial;
                this.games = res?.data?.list?.map(item => {
                    if (item.imageId === 'i-jjor8017ca686bktuqruan459686' || item.imageId === 'i-abor8a9d8f39uz8v9h9njm98a886') {
                        showAppTips = false;
                        isSpecial = true;
                    } else {
                        showAppTips = true;
                        isSpecial = false;
                    }
                    return {
                        gameId: item.imageId,
                        appName: item.showName,
                        appDesc: item.description,
                        showAppTips,
                        imageName: item.imageName,
                        isSpecial,
                        ids: item.ids,
                        iconUrl: item.iconUrl
                    }
                });
                this.selectedGame = this.games[0];
                this.selectedImageId = this.selectedGame.gameId;

                this.getAvailableOSTimeout();
            });
        },
        // getAvailableOS() {
        //     const param = { region: this.selectedRegion, deviceType: this.selectedModel };
        //     Ajax.get('/api/cps/getAvailableOS', param).then(res => {
        //         // 根据成琳要求写死name相关信息，并且取返回的镜像第一项
        //         let games = res.data.oss.map(item => {
        //             return {
        //                 gameId: item.osTypeId,
        //                 appName: "黑神话悟空",
        //                 appDesc: "《黑神话：悟空》是一款以《西游记》为背景的动作角色扮演游戏。",
        //                 appTips: this.$t("game.create.tips.wukong"),
        //                 imageName: item.osName
        //             }
        //         }).filter((item, index) => {
        //             return index === 0
        //         });
        //         this.games = games;
        //         this.selectedGame = this.games[0];

        //     }).catch(async (err) => {
        //         const { response } = err.data;
        //         try {
        //             const json = await response.json();
        //             this.$message.error(json.errmsg);
        //         } catch (ex) {
        //             console.log(ex);
        //         }
        //     });

        // },
        getAvailableRaids(selectedModel) {
            if (!selectedModel) return;
            let param = {
                deviceType: selectedModel,
                region: this.selectedRegion
            };
            Ajax.get('/api/cps/getAvailableRaids', param).then(res => {
                this.systemRaid = res.data.raids.filter(item => item.volumeType === 'system').reduce((init, curr) => {
                    const volume1 = curr.volumeDetail.split('(').join(' (');
                    const volume = volume1.split(')');
                    const raidType = `${this.radisNameMap[curr.raidType]})`;
                    init.sysRaidTypeId = curr.raidTypeId;
                    init.sysRaidName = volume + raidType;
                    return init
                }, {});
            }).catch(async (err) => {
                const { response } = err.data || {};
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            });
        },
        selectDeviceType(item) {
            if (!this.deviceTypes[item.deviceType]) {
                return
            }
            this.selectedDeviceType = item;
            this.selectedModel = item.deviceType;
            this.selectedDeviceTypeId = item.id;
            this.selectedBw = item.bw;
            this.getCalculateTotalPrice();

        },
        getModels() {
            let params = {
                region: this.selectedRegion,
                az: this.selectedAz,
            };
            getGameSpecsApi(params)
                .then(async res => {
                    this.skuloading = false;
                    this.models = res.data.specs;
                    // 旧逻辑 下个版本可删除 TODO
                    // this.selectedDeviceType = this.models[0];
                    // this.selectedModel = this.models[0].deviceType;
                    // this.selectedDeviceTypeId = this.models[0].id;
                    // this.selectedBw = this.models[0].bw;
                    // this.getCalculateTotalPrice();
                    const promisesList = this.models.map(item => {
                        return this.checkStockEnough(this.selectedRegion, this.selectedAz, item.deviceType, this.selectedQuantity, item)
                    });
                    await Promise.all(promisesList);
                    let tempId = ''
                    for (const it in this.deviceTypesIds) {
                        if (!tempId && this.deviceTypesIds[it]) {
                            tempId = it
                        }
                    }
                    if (tempId) {
                        const filterModel = this.models.find(ite => String(ite.id) === String(tempId));
                        this.selectedDeviceType = filterModel;
                        this.selectedModel = filterModel.deviceType;
                        this.selectedDeviceTypeId = filterModel.id;
                        this.selectedBw = filterModel.bw;
                    } else {
                        // 这里逻辑看 550-562 行，根据ids取值对应的 配置，不能默认选中第一个
                        const selectedImageIdData = this.games?.length && this.games.find(item => {
                            return item.gameId === this.selectedImageId;
                        })
                        const modelsIndex = selectedImageIdData && this.models.findIndex(item => {
                            return item.id === selectedImageIdData.ids[0];
                        })
                        if (modelsIndex >= 0) {
                            this.selectedDeviceType = this.models[modelsIndex];
                            this.selectedModel = this.models[modelsIndex].deviceType;
                            this.selectedDeviceTypeId = this.models[modelsIndex].id;
                            this.selectedBw = this.models[modelsIndex].bw;
                        }
                        // this.selectedDeviceType = this.models[0];
                        // this.selectedModel = this.models[0].deviceType;
                        // this.selectedDeviceTypeId = this.models[0].id;
                        // this.selectedBw = this.models[0].bw;
                    }
                    if (!this.modelsList?.length) {
                        this.countLoading = false;
                        return;
                    }
                    this.getCalculateTotalPrice();
                    this.fetchPricesAndUpdateModels();
                })
                .catch(async (err) => {
                    const { response } = err.data || {};
                    try {
                        if (response) {
                            const json = await response.json();
                            this.$message.error(json.errmsg);
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                }).finally(() => { });
        },
        // 获取计费信息
        getCalculateTotalPrice() {
            // 新逻辑，如果配置信息空数据，不请求价格
            if (!this.modelsList?.length) {
                this.countLoading = false;
                return;
            } 
            this.countLoading = true;
            let params = {
                cmd: 1, // 创建
                region: this.selectedRegion,
                // 主网口
                internetChargeMode: this.chargeMode,
                bw: this.selectedBw, // 带宽
                count: this.selectedQuantity,
                deviceType: this.selectedModel,
                createType: CreateTypeConstant.VPC,
                billingType: this.chargeMode
            }
            if (this.chargeMode === 3) {
                params.timeUnit = 3;
                params.timeSpan = this.selectedMonth;
            }
            getCalculateTotalPriceApi(params).then((res) => {
                if (res?.data) {
                    this.countLoading = false
                    const { discountedTotalPrice, totalDiscount, totalOriginalPrice, list } = res?.data || {};
                    this.discountByConfigurationsPricePerHour = changeTwoDecimal(discountedTotalPrice);
                    this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalOriginalPrice, discountedTotalPrice)) : null;
                    //配置费用
                    this.feeDetailData = list.map((item, index) => {
                        return {
                            itemName: index === 0 ? "实例" : "公网带宽",
                            originalPrice: `￥${changeTwoDecimal(item.originalPrice)}`,
                            // discount: `￥${changeTwoDecimal(item.discount)}`,
                            discount: item.discount ? `${changeTwoDecimal(mulDecimals(divDecimals(subDecimals(item.originalPrice, item.discount), item.originalPrice), 10))}折` : '--',
                            itemAfterFavorablePrice: `￥${changeTwoDecimal(item.discountedPrice)}`
                        }
                    });

                    this.feeDetailData.push({
                        itemName: '合计费用',
                        originalPrice: `￥${changeTwoDecimal(totalOriginalPrice)}`,
                        discount: totalDiscount ? `${changeTwoDecimal(mulDecimals(divDecimals(subDecimals(totalOriginalPrice, totalDiscount), totalOriginalPrice), 10))}折` : '--',
                        itemAfterFavorablePrice: `￥${changeTwoDecimal(discountedTotalPrice)}`
                    });

                }
            }).catch(async (err) => {
                const { response } = err.data || {};
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            }).finally(() => { });
        },

        /**
         * 更新models单价
         */
        async fetchPricesAndUpdateModels() {
            this.everyCountLoading = true;
            try {
                const promises = this.models.map(item => {
                    return getCalculateTotalPriceApi({
                        cmd: 1, // 创建
                        region: this.selectedRegion,
                        // 主网口
                        internetChargeMode: this.chargeMode,
                        bw: item.bw, // 带宽
                        count: this.selectedQuantity,
                        deviceType: item.deviceType,
                        createType: CreateTypeConstant.VPC,
                        billingType: this.chargeMode,
                        timeUnit: this.chargeMode === 3 ? 3 : '',
                        timeSpan: this.chargeMode === 3 ? 1 : ''
                    }).then(res => {
                        const { discountedTotalPrice, totalDiscount, totalOriginalPrice } = res?.data || {}
                        // const price = changeTwoDecimal(res.data.discountedTotalPrice);
                        return { ...item, 'discountByConfigurationsPricePerHour': changeTwoDecimal(discountedTotalPrice), 'totalOriginalPrice': changeTwoDecimal(totalOriginalPrice), 'totalDiscount': totalDiscount };
                    }).catch(error => {
                        // 在这里处理单个Promise的错误
                        console.error('Error fetching price for SKU:', item, error);
                        // 返回一个包含错误信息的对象或者一个空对象
                        return { ...item, 'discountByConfigurationsPricePerHour': null, 'totalOriginalPrice': null, 'totalDiscount': null };
                    });
                });
                this.models = await Promise.all(promises);
            } finally {
                this.everyCountLoading = false;
            }
        },

        checkStockEnough(region, az, deviceType, selectedQuantity, itemData) {
            if (!region || !az || !deviceType) {
                return;
            }
            const param = {
                region,
                az,
                deviceType: deviceType,
                count: selectedQuantity
            };
            return Ajax.get('/api/bm/isStockEnough', param).then(res => {
                this.deviceTypes[deviceType] = res.data;
                // 因为deviceType存在相同的情况，可能只有带宽不同，使得根据deviceType不能区分，故通过id进行区分，才能记住数组下标
                // 相当于给每个配置项加一个是否有库存的标识，方便下一步根据这个标识来进行默认选择
                this.deviceTypesIds[itemData.id] = res.data;
            }).catch(async (err) => {
                const { response } = err.data || {};
                try {
                    if (response) {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    }
                } catch (ex) {
                    console.log(ex);
                }
            });
        },

        changePwdEyes() {
            this.pwdEyes = !this.pwdEyes;
        },
        changeConfirmPwdEyes() {
            this.confirmPwdEyes = !this.confirmPwdEyes;
        },
        generatePwd() {
            // const pwd = generatePassword3();
            const pwd = local_generatePassword3();
            this.ruleForm.hostPwd = pwd;
        },
        changeCard(item) {
            this.selectedGame = item;
            this.selectedImageId = item.gameId;
        },
        changeMonth() {
            this.getCalculateTotalPrice();
        }
    }
};
</script>
<style lang="scss">
@import '../../../assets/scss/createCommon';
@import '../../../assets/scss/statusCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/gameInstance/create/Create.vue